import dayjs from 'dayjs';
import * as i18next from 'i18next';
import { DATE_FORMAT_MOOD_TRACKER } from '../../helpers';
import { IsabelQuestion, IsabelTriageScoreUrlParser } from './models';

export const ISABEL_ITEMS_TO_SHOW_PER_ITERATION = 5;
export const termsUrl =
  'https://symptomchecker.isabelhealthcare.com/SC-terms-conditions';

export const generateIsabelReportName = () => {
  return `carecircle_isabel_report_${dayjs
    .utc(new Date())
    .format(DATE_FORMAT_MOOD_TRACKER)}`;
};

export const getIsabelQuestions = (t: i18next.TFunction): IsabelQuestion[] => [
  {
    id: 0,
    text: t('health_picture_isabel_get_care_question1'),
    answers: [
      {
        text: t('health_picture_isabel_get_care_answer11'),
        value: 1,
      },
      {
        text: t('health_picture_isabel_get_care_answer12'),
        value: 2,
      },
      {
        text: t('health_picture_isabel_get_care_answer13'),
        value: 3,
      },
      {
        text: t('health_picture_isabel_get_care_answer14'),
        value: 4,
      },
    ],
  },
  {
    id: 1,
    text: t('health_picture_isabel_get_care_question2'),
    answers: [
      {
        text: t('health_picture_isabel_get_care_answer21'),
        value: 1,
      },
      {
        text: t('health_picture_isabel_get_care_answer22'),
        value: 2,
      },
      {
        text: t('health_picture_isabel_get_care_answer23'),
        value: 3,
      },
    ],
  },
  {
    id: 2,
    text: t('health_picture_isabel_get_care_question3'),
    answers: [
      {
        text: t('health_picture_isabel_get_care_answer31'),
        value: 1,
      },
      {
        text: t('health_picture_isabel_get_care_answer32'),
        value: 2,
      },
      {
        text: t('health_picture_isabel_get_care_answer33'),
        value: 3,
      },
    ],
  },
  {
    id: 3,
    text: t('health_picture_isabel_get_care_question4'),
    answers: [
      {
        text: t('health_picture_isabel_get_care_answer41'),
        value: 1,
      },
      {
        text: t('health_picture_isabel_get_care_answer42'),
        value: 2,
      },
      {
        text: t('health_picture_isabel_get_care_answer43'),
        value: 3,
      },
      {
        text: t('health_picture_isabel_get_care_answer44'),
        value: 4,
      },
    ],
  },
  {
    id: 4,
    text: t('health_picture_isabel_get_care_question5'),
    answers: [
      {
        text: t('health_picture_isabel_get_care_answer51'),
        value: 1,
      },
      {
        text: t('health_picture_isabel_get_care_answer52'),
        value: 2,
      },
      {
        text: t('health_picture_isabel_get_care_answer53'),
        value: 3,
      },
    ],
  },
  {
    id: 5,
    text: t('health_picture_isabel_get_care_question6'),
    answers: [
      {
        text: t('health_picture_isabel_get_care_answer61'),
        value: 1,
      },
      {
        text: t('health_picture_isabel_get_care_answer62'),
        value: 2,
      },
      {
        text: t('health_picture_isabel_get_care_answer63'),
        value: 3,
      },
    ],
  },
  {
    id: 6,
    text: t('health_picture_isabel_get_care_question7'),
    answers: [
      {
        text: t('health_picture_isabel_get_care_answer63'),
        value: 1,
      },
      {
        text: t('health_picture_isabel_get_care_answer62'),
        value: 2,
      },
    ],
  },
];

export const getIsabelQuestionResponses = (
  t: i18next.TFunction
): IsabelQuestion[] => [
  {
    id: 0,
    text: t('health_picture_isabel_get_care_result_question1'),
    answers: getIsabelQuestions(t)[0].answers,
  },
  {
    id: 1,
    text: t('health_picture_isabel_get_care_result_question2'),
    answers: getIsabelQuestions(t)[1].answers,
  },
  {
    id: 2,
    text: t('health_picture_isabel_get_care_result_question3'),
    answers: getIsabelQuestions(t)[2].answers,
  },
  {
    id: 3,
    text: t('health_picture_isabel_get_care_result_question4'),
    answers: getIsabelQuestions(t)[3].answers,
  },
  {
    id: 4,
    text: t('health_picture_isabel_get_care_result_question5'),
    answers: getIsabelQuestions(t)[4].answers,
  },
  {
    id: 5,
    text: t('health_picture_isabel_get_care_result_question6'),
    answers: getIsabelQuestions(t)[5].answers,
  },
  {
    id: 6,
    text: t('health_picture_isabel_get_care_result_question7'),
    answers: getIsabelQuestions(t)[6].answers,
  },
];

export const convertTriageUrlToObject = (
  url: string
): IsabelTriageScoreUrlParser => {
  const trimmedTriageUrl = url.split('?')[1];
  return JSON.parse(
    '{"' +
      decodeURI(trimmedTriageUrl)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
      '"}'
  );
};

export enum IsabelGender {
  MALE = 'm',
  FEMALE = 'f',
}

export enum IsabelPregnancy {
  PREGNANT = 'y',
  NOT_PREGNANT = 'n',
  DONT_KNOW = 'dk',
}

export enum IsabelScreens {
  ISABEL_CHECK_SYMPTOMS = 0,
  ISABEL_RESULTS = 1,
  ISABEL_GET_CARE = 2,
  ISABEL_GET_CARE_RESULTS = 3,
  ISABEL_DIAGNOSIS = 4,
}

export enum IsabelTimelineScreens {
  ISABEL_RESULTS = 0,
  ISABEL_DIAGNOSIS = 1,
}

export enum SymptomCheckerSteps {
  SYMPTOMS = 1,
  POSSIBLE_CONDITIONS = 2,
  TRIAGE = 3,
  RESULTS = 4,
}

export enum ModeratorEditReasons {
  DISRESPECTFUL_INTERACTIONS = 'disrespectful_interactions',
  CRIMINAL_UNETHICAL_ACTIVITY = 'criminal_unethical_activity',
  MISLEADING_INFO = 'misleading_info',
  RELEVANCY_TO_DISCUSSION = 'relevancy_to_discussion',
  NO_SHARING_PERMISSION = 'no_sharing_permission',
}
